import { render, staticRenderFns } from "./setting_analytic.vue?vue&type=template&id=138072ec"
import script from "./setting_analytic.vue?vue&type=script&lang=js"
export * from "./setting_analytic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports